import React from 'react';
import {Link} from "react-router-dom";
import {convertTime} from "./helper";

export const tableColumns = [
    {
        Header: "Scorecard Name",
        id: "scorecardName",
        accessor: row => <div className="ComputedScorecardTableCell"><Link id={row.id} to={`/scorecard/view/${row.scorecardTemplateId}`}>{row.scorecardName}</Link> </div>
    },
    {
        Header: "Corporate Name",
        accessor: "corporateName",
        Cell: row => <div className="ComputedScorecardTableCell"><span title={row.value}>{row.value}</span></div>
    },
    {
        Header: "Counterparty Name",
        accessor: "counterpartyName",
        Cell: row => <div className="ComputedScorecardTableCell"><span title={row.value}>{row.value}</span></div>
    },
    {
        Header: "Rubix Risk Score",
        accessor: "totalScore",
        style:{
            textAlign: 'center'
        },
        Cell: row => (row.value) ? row.value.toFixed(1) : ''
    },
    {
        Header: "Risk Grade",
        accessor: "computedRiskGrade"
    },
    {
        Header: "Updated On",
        accessor: "updatedAt",
        sortMethod: (a, b) => {
            if (a === b) {
                return 0;
            }
            return a > b ? -1 : 1;
        },
        Cell: row => <div className="ComputedScorecardTableCell"><span title={row.value}>{convertTime(row.value)}</span></div>,

    }
]
